import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trezo-card bg-white dark:bg-[#0c1427] rounded-md"
}
const _hoisted_2 = {
  key: 1,
  class: "trezo-card bg-white dark:bg-[#0c1427] rounded-md"
}
const _hoisted_3 = { class: "trezo-card-content px-[20px] md:px-[25px] pb-[20px] md:pb-[25px] text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-md mb-[3px]" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-between mb-[11px] last:mb-0"
}
const _hoisted_8 = { class: "block" }
const _hoisted_9 = {
  key: 1,
  class: "flex items-center justify-between mb-[11px] last:mb-0"
}
const _hoisted_10 = { class: "block" }
const _hoisted_11 = {
  key: 2,
  class: "flex items-center justify-between mb-[11px] last:mb-0"
}
const _hoisted_12 = { class: "block" }
const _hoisted_13 = {
  key: 3,
  class: "flex items-center justify-between mb-[11px] last:mb-0"
}
const _hoisted_14 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "flex justify-center items-center p-8" }, [
          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500 opacity-75" })
        ], -1)
      ])))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "h-[120px] rounded-t-md",
          style: {"background":"linear-gradient(101deg, #605dff 0%, #605dff 100%)"}
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.assignedUser?.profile_picture_link || _ctx.placeholderImage,
            class: "inline-block rounded-full w-[167px] h-[167px] mb-[16px] -mt-[83px] object-cover",
            alt: "user-image"
          }, null, 8, _hoisted_4),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.assignedUser?.display_name || 'Unassigned'), 1),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "block" }, " Property Representative ", -1)),
          _createElementVNode("ul", _hoisted_6, [
            (_ctx.property?.id)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block text-black dark:text-white" }, " Property ID: ", -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.shortenId(_ctx.property.id)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.property?.year_built)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "block text-black dark:text-white" }, " Year Built: ", -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.property.year_built), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.property?.property_type)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "block text-black dark:text-white" }, " Property Type: ", -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatPropertyType(_ctx.property.property_type)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.property?.created_at)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "block text-black dark:text-white" }, " Listing Date: ", -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.property.created_at)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}